<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="750px"
        append-to-body>
        <div slot="title">
            <p class="ellipsis pr20">
                <span class="text-bold inline-block ver-middle ellipsis" style="max-width: 500px;">
                    <span v-html="msg.title"></span>
                </span>
                <span class="text-color-gray ml20">{{msg.created_at}}</span>
            </p>
        </div>
        <div class="content-wrap" @click="clickCon">
            <div v-html="msg.message"></div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "MessageModal",
        data() {
            return {
                dialogVisible: false,
            }
        },
        props:{
            msg:Object,
        },
        created(){

        },
        methods: {
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    let read = (this.msg||{}).is_read;
                    if(read==0){
                        this.$emit('read',this.msg);
                    }
                })
            },
            clickCon(e){
                let $target = e.target;
                let classList = Array.from($target.classList);
                if(classList.includes('action-btn')){
                    let dataPage = $target.getAttribute('data-page');
                    let dataId = $target.getAttribute('data-id');
                    let rangeTime = $target.getAttribute('range-time');
                    if(dataPage=="intelligentTriggerRecordPage"){
                        let $router = this.$router.resolve({
                            name:'intelligent_managed_rule',
                            query: {
                                url:'TriggerRecordPage',
                                id:dataId,
                                range_time:rangeTime,
                                t: new Date().getTime(),
                            },
                        });
                        window.open($router.href, '_blank');
                    }
                }
            },
        },
    }
</script>

<style lang="scss" scoped >
    .content-wrap{
        max-height: 450px;
        overflow-y: auto;

        ::v-deep a {
            color: -webkit-link;
        }

        ::v-deep ul{
            list-style: disc inside;
        }
        ::v-deep ol{
            list-style: decimal inside;
        }
    }
</style>
